import React from 'react'
import SlidingPane from "react-sliding-pane";
import Form from "react-validation/build/form";
import Tooltip from "@tippyjs/react";
import "react-toastify/dist/ReactToastify.css";
import "tippy.js/dist/tippy.css";
import { getTrans as t } from "../../../Localization/translations";
import CheckButton from "react-validation/build/button";


const CreateAddress = ({state2,setState2,handleSubmit3,handleAddressforInstall,form3,installaddress_line_1,register3,
    setInstallAddress_line_1,errors3,setInstallAddress_line_2,installaddress_line_2,installcountryid,handlecountryInstall,
    country_name,install_stateaddressId,handlestateInstall,install_state_name,installcity,setInstallCity,installzip_code,
    setInstallZip_code,checkBtn3
}) => {
  return (
    <SlidingPane
        className="some-custom-class sidepanebar"
        isOpen={state2.isPaneOpen}
        title="Add Address"
        subtitle=""
        onRequestClose={() => {
          setState2({ isPaneOpen: false });
        }}
      >
        <Form
          role="form text-left"
          onSubmit={handleSubmit3(handleAddressforInstall)}
          ref={form3}
          key={3}
          action="."
          method="POST"
          id="addReceiptForm"
        >
          {
            <>
              <div className="row">
                <div className="form-group row">
                  <div className="col-md-6">
                    <label className="col-form-label required">
                      {t("Address Line 1")}{" "}
                      <Tooltip content={t("Address_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <input
                      placeholder={t("Address Line 1")}
                      className="form-control"
                      type="text"
                      name="installaddress_line_1"
                      maxLength="200"
                      id="id_address_line_1"
                      value={installaddress_line_1}
                      {...register3("installaddress_line_1", {
                        onChange: (e) => {
                          setInstallAddress_line_1(e.target.value);
                        },
                        required: true,
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors3.installaddress_line_1?.type === "required" &&
                        "Address is required"}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="col-form-label">
                      {t("Address Line 2")}{" "}
                      <Tooltip content={t("Address2_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <input
                      placeholder={t("Address Line 2")}
                      className="form-control"
                      type="text"
                      onChange={(e) =>
                        setInstallAddress_line_2(e.target.value)
                      }
                      name="installaddress_line_2"
                      maxLength="200"
                      id="id_address_line_2"
                      value={installaddress_line_2}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label className="col-form-label required">
                      {t("Country")}{" "}
                      <Tooltip content={t("Country_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <select
                      type="text"
                      className="form-control"
                      value={installcountryid}
                      name="installcountry"
                      // onChange={(e) => handlecountry(e)}
                      {...register3("installcountry", { onChange: (e) => { handlecountryInstall(e) }, required: true })}
                    >
                      <option value="">---{t("Select Country")}---</option>
                      {
                        country_name.map((country, i) =>
                        (
                          <option key={i} value={country.id} >{country.name}</option>
                        ))
                      }
                    </select>
                    <div className="invalid-feedback">
                      {errors3.installcountry?.type === "required" &&
                        "Country is required"}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="col-form-label required">
                      {t("State")}{" "}
                      <Tooltip content={t("State_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <select
                      value={install_stateaddressId}
                      className="form-control"
                      name="installstate"
                      // onChange={(e) => handlestate(e)}
                      {...register3("installstate", { onChange: (e) => { handlestateInstall(e) }, required: true })}
                    >
                      <option value="">---{t("Select State")}---</option>
                      {
                        install_state_name.map((resst, i) => (
                          <option key={i} value={resst.id} >{resst.name}</option>
                        ))
                      }
                    </select>
                    <div className="invalid-feedback">
                      {errors3.installstate?.type === "required" &&
                        "State is required"}
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <label className="col-form-label required">
                      {t("City")}{" "}
                      <Tooltip content={t("City_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <input
                      placeholder={t("City")}
                      className="form-control"
                      type="text"
                      name="installcity"
                      maxLength="100"
                      id="id_city"
                      value={installcity}
                      {...register3("installcity", {
                        onChange: (e) => {
                          setInstallCity(e.target.value);
                        },
                        required: true,
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors3.installcity?.type === "required" &&
                        "City is required"}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="col-form-label required">
                      {t("Zip Code")}{" "}
                      <Tooltip content={t("ZipCode_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <input
                      placeholder={t("Zip Code")}
                      className="form-control"
                      type="text"
                      name="installzip_code"
                      maxLength="30"
                      id="id_zip_code"
                      value={installzip_code}
                      {...register3("installzip_code", {
                        onChange: (e) => {
                          setInstallZip_code(e.target.value);
                        },
                        required: true,
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors3.installzip_code?.type === "required" &&
                        "Zip Code is required"}
                    </div>
                  </div>

                </div>
              </div>
              <button
                type="submit"
                className="border-0 btn btn-primary btn-gradient-primary btn-md"
              >
                {t("Save")}
              </button>
              &nbsp;&nbsp;
            </>
          }
          <CheckButton style={{ display: "none" }} ref={checkBtn3} />
        </Form>
      </SlidingPane>
  )
}

export default CreateAddress